<template>
    <div class="data-container">
        <div class="content-container">
            <div class="left-menu">
                <el-menu :default-openeds="openeds" class="el-menu-vertical" :router="true" :default-active="activeIndex">
                    <el-menu-item index="/data/index">
                        <i class="el-icon-house"></i>
                        <span>首页</span>
                    </el-menu-item>
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-location-information"></i>
                            <span>地址数据</span>
                        </template>
                        <el-menu-item index="/data/listAddress">数据列表</el-menu-item>
                        <el-menu-item index="/data/addAddress">新增数据</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="right-content">
                <router-view name="contentRouter"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Data',
    components: {},
    data() {
        return {
            openeds: ['1', '2', '3'],
            activeIndex: ''
        }
    },
    created() {
    },
    mounted() {
        this.activeIndex = this.$route.path
    },
    beforeDestroy() {
    },
    methods: {

    },
    watch: {
        $route(to, from) {
            this.activeIndex = to.path
        }
    }
}
</script>

<style lang="scss" scoped>

.data-container {
    background: #f2f2f2;
    height: calc(100vh - 111px);
    .content-container{
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .right-content{
        }
        .left-menu{
            width: 300px;
            .el-menu-vertical{
                height: 100%;
                border-top: solid 1px #e6e6e6;
            }
        }
    }
}
</style>

